import { memo, FC } from 'react';
import classes from './Point.module.scss';
import { useTranslation,Trans } from 'react-i18next';

import { BubbleBase } from "../../../common/BubbleBase";

interface Props {
  className?: string;
  classes?: {
    root?: string;
  };
}


export const Point3_2: FC<Props> = memo(function Point3_2(props) {
  const { t } = useTranslation();
  return (
     <div className={classes.slideContent}>
      <div className={classes.circleBubble}>
        <BubbleBase className={classes.circleBubbleBase} />
        <div className={classes.circleBubbleBaseText}>
          <span className={classes.circleBubbleBaseSmallText}>{t('about:point.03.part2.Bubble').split('</span>')[0]}</span>
          {t('about:point.03.part2.Bubble').split('</span>')[1]}
        </div>
      </div>
      <div className={`${classes.questionBlock} ${classes.part2}`}>
        <h4 className={classes.questionTitle}>{t('about:point.03.part2.questionTitle01')}</h4>
        <ul className={classes.choiceList}>
          <li className={classes.choiceItem}>{t('about:point.03.part2.choiceItem01')}<span>79 %</span></li>
          <li className={classes.choiceItem}>{t('about:point.03.part2.choiceItem02')}<span>74 %</span></li>
          <li className={classes.choiceItem}>{t('about:point.03.part2.choiceItem03')}<span>72 %</span></li>
          <li className={classes.choiceItem}>{t('about:point.03.part2.choiceItem04')}<span>70 %</span></li>
        </ul>
      </div>
      <small>{t('about:point.03.part2.amendment')}</small>
    </div>
  
  );
});

